import styled from 'styled-components'

export const Inner = styled.div`
  padding: 27px 42px 27px 40px;
  overflow-x: hidden;
  overflow-y: auto;
`

export const s = { Inner }
